module.exports = __webpack_public_path__ + "img/corsi_online_risposte_pesi_smartform.eef1cfc2.png";